import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ClientsFeatureKey } from './clients-feature-key';
import { ClientsState } from './clients.state';

export const ClientsFeatureSelector =
  createFeatureSelector<ClientsState>(ClientsFeatureKey);
// All Clients
export const allClientsSelector = createSelector(
  ClientsFeatureSelector,
  (state) => {
    return state.allClients;
  }
);
// Create Client
export const createClientSelector = createSelector(
  ClientsFeatureSelector,
  (state) => {
    return state.createClient;
  }
);
// Update Client
export const updateClientSelector = createSelector(
  ClientsFeatureSelector,
  (state) => {
    return state.updateClient;
  }
);
// Remove and Assign Requests
export const removeAndAssignSelector = createSelector(
  ClientsFeatureSelector,
  (state) => {
    return state.removeAndAssign;
  }
);
// Create Multiple Members
export const addMultipleMembersSelector = createSelector(
  ClientsFeatureSelector,
  (state) => {
    return state.addMultipleMembers;
  }
);
// Remove Client
export const removeClientSelector = createSelector(
  ClientsFeatureSelector,
  (state) => {
    return state.removeClient;
  }
);
// Client By Id
export const clientByIdSelector = createSelector(
  ClientsFeatureSelector,
  (state) => {
    return state.clientById;
  }
);

// Remove Member
export const removeMemberSelector = createSelector(
  ClientsFeatureSelector,
  (state) => {
    return state.removeMember;
  }
);

// Member By Id
export const memberByIdSelector = createSelector(
  ClientsFeatureSelector,
  (state) => {
    return state.memberById;
  }
);

// Update Member
export const updateMemberSelector = createSelector(
  ClientsFeatureSelector,
  (state) => {
    return state.updateMember;
  }
);

// Add Member
export const addMemberSelector = createSelector(
  ClientsFeatureSelector,
  (state) => {
    return state.addMember;
  }
);
// Add Member
export const pendingRequestsByMemberSelector = createSelector(
  ClientsFeatureSelector,
  (state) => {
    return state.pendingRequestByMember;
  }
);

/**
 * All Clients Selector
 */
export const allClientsSuccessSelector = createSelector(
  allClientsSelector,
  (state) => {
    return state.data;
  }
);
export const allClientsFailureSelector = createSelector(
  allClientsSelector,
  (state) => {
    return state.failure;
  }
);
export const allClientsLoadingSelector = createSelector(
  allClientsSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Create Client Selector
 */
export const createClientSuccessSelector = createSelector(
  createClientSelector,
  (state) => {
    return state.data;
  }
);
export const createClientFailureSelector = createSelector(
  createClientSelector,
  (state) => {
    return state.failure;
  }
);
export const createClientLoadingSelector = createSelector(
  createClientSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Remove Client Selector
 */
export const removeClientSuccessSelector = createSelector(
  removeClientSelector,
  (state) => {
    return state.data;
  }
);
export const removeClientFailureSelector = createSelector(
  removeClientSelector,
  (state) => {
    return state.failure;
  }
);
export const removeClientLoadingSelector = createSelector(
  removeClientSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Client By Id Selector
 */
export const clientByIdSuccessSelector = createSelector(
  clientByIdSelector,
  (state) => {
    return state.data;
  }
);
export const clientByIdFailureSelector = createSelector(
  clientByIdSelector,
  (state) => {
    return state.failure;
  }
);
export const clientByIdLoadingSelector = createSelector(
  clientByIdSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Remove Member Selector
 */
export const removeMemberSuccessSelector = createSelector(
  removeMemberSelector,
  (state) => {
    return state.data;
  }
);
export const removeMemberFailureSelector = createSelector(
  removeMemberSelector,
  (state) => {
    return state.failure;
  }
);
export const removeMemberLoadingSelector = createSelector(
  removeMemberSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Member By Id Selector
 */
export const memberByIdSuccessSelector = createSelector(
  memberByIdSelector,
  (state) => {
    return state.data;
  }
);
export const memberByIdFailureSelector = createSelector(
  memberByIdSelector,
  (state) => {
    return state.failure;
  }
);
export const memberByIdLoadingSelector = createSelector(
  memberByIdSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Update Member Selector
 */
export const updateMemberSuccessSelector = createSelector(
  updateMemberSelector,
  (state) => {
    return state.data;
  }
);
export const updateMemberFailureSelector = createSelector(
  updateMemberSelector,
  (state) => {
    return state.failure;
  }
);
export const updateMemberLoadingSelector = createSelector(
  updateMemberSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Add Member Selector
 */
export const addMemberSuccessSelector = createSelector(
  addMemberSelector,
  (state) => {
    return state.data;
  }
);
export const addMemberFailureSelector = createSelector(
  addMemberSelector,
  (state) => {
    return state.failure;
  }
);
export const addMemberLoadingSelector = createSelector(
  addMemberSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Update Client Selector
 */
export const updateClientSuccessSelector = createSelector(
  updateClientSelector,
  (state) => {
    return state.data;
  }
);
export const updateClientFailureSelector = createSelector(
  updateClientSelector,
  (state) => {
    return state.failure;
  }
);
export const updateClientLoadingSelector = createSelector(
  updateClientSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Pending Request By Client Selector
 */
export const pendingRequestsByMemberSuccessSelector = createSelector(
  pendingRequestsByMemberSelector,
  (state) => {
    return state.data;
  }
);
export const pendingRequestsByMemberFailureSelector = createSelector(
  pendingRequestsByMemberSelector,
  (state) => {
    return state.failure;
  }
);
export const pendingRequestsByMemberLoadingSelector = createSelector(
  pendingRequestsByMemberSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Add Multiple Member Selector
 */
export const addMultipleMembersSuccessSelector = createSelector(
  addMultipleMembersSelector,
  (state) => {
    return state.data;
  }
);
export const addMultipleMembersFailureSelector = createSelector(
  addMultipleMembersSelector,
  (state) => {
    return state.failure;
  }
);
export const addMultipleMembersLoadingSelector = createSelector(
  addMultipleMembersSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Remove And Assign
 */
export const removeAndAssignSuccessSelector = createSelector(
  removeAndAssignSelector,
  (state) => {
    return state.data;
  }
);
export const removeAndAssignFailureSelector = createSelector(
  removeAndAssignSelector,
  (state) => {
    return state.failure;
  }
);
export const removeAndAssignLoadingSelector = createSelector(
  removeAndAssignSelector,
  (state) => {
    return state.loading;
  }
);
